// extracted by mini-css-extract-plugin
export default {"button":"ClearButton__button--Ydf7T","hover":"ClearButton__hover--3nRSV"};